
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 16, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

export default {
	title: "Comment",
	description: "myhealth.commentheading",
	type: "object",
	properties: {
		comment: {
			description: "bloodoxygen.commenttitle",
			type: "string",
			multiline: true,
			placeholder: "bloodoxygen.comment"
		}
	}
};
